import { render, staticRenderFns } from "./EmployeeInfo.vue?vue&type=template&id=853e8ee4&scoped=true"
import script from "./EmployeeInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeInfo.vue?vue&type=script&lang=js"
import style0 from "./EmployeeInfo.vue?vue&type=style&index=0&id=853e8ee4&prod&scoped=true&lang=css"
import style1 from "./EmployeeInfo.vue?vue&type=style&index=1&id=853e8ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853e8ee4",
  null
  
)

export default component.exports